import api, { setAuthContext } from './api';

class AuthService {
  /**
   * Set auth context (called from App.js)
   */
  setContext(context) {
    console.log('🔐 AuthService.setContext() called');
    setAuthContext(context);
  }

  /**
   * Admin login
   */
  async login(email, password) {
    try {
      const response = await api.post('/auth/login', { email, password });

      if (response.data.success) {
        const { user, token } = response.data.data;

        // Only allow admin role
        if (user.role !== 'admin') {
          throw new Error('Access denied. Admin privileges required.');
        }

        // Store token and user in localStorage for persistence
        localStorage.setItem('adminToken', token);
        localStorage.setItem('adminUser', JSON.stringify(user));
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Logout admin
   */
  logout() {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
  }

  /**
   * Get admin profile
   */
  async getProfile() {
    try {
      const response = await api.get('/auth/profile');

      if (response.data.success) {
        // Store updated user data in localStorage
        localStorage.setItem('adminUser', JSON.stringify(response.data.data.user));
      }

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Check if admin is logged in
   */
  isLoggedIn() {
    const token = localStorage.getItem('adminToken');
    const user = this.getStoredUser();
    return !!(token && user && user.role === 'admin');
  }

  /**
   * Get stored user data
   */
  getStoredUser() {
    try {
      const userJson = localStorage.getItem('adminUser');
      return userJson ? JSON.parse(userJson) : null;
    } catch (error) {
      return null;
    }
  }

  /**
   * Get stored token
   */
  getStoredToken() {
    return localStorage.getItem('adminToken');
  }

  /**
   * Handle API errors
   */
  handleError(error) {
    let errorMessage;

    if (error.response) {
      errorMessage = error.response.data.message || 'An error occurred';
    } else if (error.request) {
      errorMessage = 'Network error. Please check your connection.';
    } else {
      errorMessage = error.message || 'An unexpected error occurred';
    }

    // Create a proper Error object with the message
    const err = new Error(errorMessage);
    err.errors = error.response?.data?.errors || [];
    err.status = error.response?.status || 0;
    return err;
  }
}

export default new AuthService();
